import React, {useState} from 'react';
import {StoryType, TagType} from "../data/StoryList";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library, IconProp} from '@fortawesome/fontawesome-svg-core'

/* import all the icons in Free Solid, Free Regular, and Brands styles */
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'

// @ts-ignore
const spinner: IconProp = 'fa fa-spinner'
// @ts-ignore
const tagIcon: IconProp = 'fa fa-tag'
// @ts-ignore
const complete: IconProp = 'fa fa-circle'
// @ts-ignore
const chapters: IconProp = 'fa fa-book'

library.add(fas, far, fab)

export default function Story({key, story}: { key: any, story: StoryType }) {
    return (
        <div id={story.id} className="story-item">
            <h4 className="story-header">
                <div className="story-link u-pl-1">
                    <a href={story.link}>
                        {story.title}
                    </a>
                </div>
                <div className="story-pairing u-pr-1">
                    {story.pairing}
                </div>
            </h4>
            <div className="story-card u-px-1 u-pb-h">
                <p> {story.description}'</p>
                <div className="story-data">
                    <h4 className="story-status">
                        <span className={'tag-bubble'}>
                            {story.completedStatus === 'Complete' ?
                                <FontAwesomeIcon className={'icon'} icon={complete}/> :
                                <FontAwesomeIcon className={'icon'} icon={spinner}/>
                            }
                            {story.completedStatus}
                        </span>
                        {story.chapters ?
                            <span className={'tag-bubble'}>
                                <FontAwesomeIcon className={'icon'} icon={chapters}/>
                                <span> Chapters: {story.chapters}</span>
                            </span>
                            : ''
                        }
                    </h4>
                    <h4>
                        {story.tags.map((tag: TagType) => {
                            return (
                                <span className={'tag-bubble'}>
                                    {/*todo make these Icons work again*/}
                                    <FontAwesomeIcon className={'icon'} icon={tagIcon}/>
                                    {tag.tagName}
                                </span>)
                        })}
                    </h4>
                </div>
            </div>
        </div>
    )
}